module.exports = __webpack_public_path__ + "assets/img/6_457_big.c4862bd2.jpg";